// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Bm-z","badgeLink":"Cm-z","category":"Dm-z"};